enum TripMode {
  AUTO = "auto",
  MANUAL = "manual",
}

export default TripMode;
